import _ from 'lodash'
import type { Ref } from 'vue'
import { watch } from 'vue'

export function useAutoCompletionDebouncedWatcher(
  inputRef: Ref<string>,
  completionItemsList,
  fetchCallback: (search: string, signal: AbortSignal) => void,
  clearCallback?: () => void,
  minLength: number = 0,
  debounceTime: number = 500
) {
  let abortController: AbortController

  const handleInputChange = _.debounce((newInput) => {
    if (abortController) {
      abortController.abort()
    }

    if (newInput && newInput !== '' && newInput.length > minLength) {
      abortController = new AbortController()
      const signal = abortController.signal

      fetchCallback(newInput, signal)
    } else if (clearCallback && completionItemsList.value.length) {
      clearCallback()
    }
  }, debounceTime)

  watch(inputRef, handleInputChange)

  return {
    cancelRequest: () => {
      if (abortController) {
        abortController.abort()
      }
    },
  }
}
